import React, { useState } from 'react';
import { submitContactMessage } from '../../utils/api';
import { useAuth } from '../../context/AuthContext';

const Contact = () => {
  const { user } = useAuth();
  const [formData, setFormData] = useState({
    name: user?.name || '',
    email: user?.email || '',
    phone: user?.phone || '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await submitContactMessage({
        ...formData,
        userId: user?._id || null
      });
      setSubmitted(true);
      setFormData({ name: '', email: '', phone: '', message: '' });
      setTimeout(() => setSubmitted(false), 5000);
    } catch (err) {
      setError('Failed to send message. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.section}>
      <div style={styles.container}>
        <p style={styles.tag}>GET IN TOUCH</p>
        <h2 style={styles.title}>Contact Us</h2>
        <p style={styles.subtitle}>Have a question? We'd love to hear from you</p>

        <div style={styles.grid} className="contact-grid" >
          {/* Contact Info */}
          <div style={styles.info}>
            {[
              { icon: '📍', title: 'Address', text: 'Clark, New Jersey, NYC' },
              { icon: '📞', title: 'Phone', text: '+1(845) 879-3936' },
              { icon: '📧', title: 'Email', text: 'info@empire1tires.com' },
              { icon: '🕐', title: 'Hours', text: '24/7 Emergency Available' },
            ].map((item, i) => (
              <div key={i} style={styles.infoItem}>
                <div style={styles.infoIconBox}>
                  <span style={styles.infoIcon}>{item.icon}</span>
                </div>
                <div>
                  <h4 style={styles.infoTitle}>{item.title}</h4>
                  <p style={styles.infoText}>{item.text}</p>
                </div>
              </div>
            ))}
            <div style={styles.socialRow}>
              <button style={styles.socialBtn}>📘 Facebook</button>
              <button style={styles.socialBtn}>📸 Instagram</button>
              <button style={styles.socialBtn}>💬 WhatsApp</button>
            </div>
          </div>

          {/* Contact Form */}
          <div style={styles.formBox}>
            <h3 style={styles.formTitle}>Send us a Message</h3>
            {submitted && (
              <div style={styles.success}>
                ✅ Message sent! We'll get back to you soon.
              </div>
            )}
            {error && (
              <div style={styles.errorBox}>⚠️ {error}</div>
            )}
            <form onSubmit={handleSubmit}>
              <div style={styles.row}>
                <input
                  style={styles.input}
                  type="text"
                  name="name"
                  placeholder="Your Name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
                <input
                  style={styles.input}
                  type="text"
                  name="phone"
                  placeholder="Phone Number"
                  value={formData.phone}
                  onChange={handleChange}
                />
              </div>
              <input
                style={{ ...styles.input, width: '100%' }}
                type="email"
                name="email"
                placeholder="Email Address"
                value={formData.email}
                onChange={handleChange}
                required
              />
              <textarea
                style={{ ...styles.input, width: '100%', height: '130px', resize: 'vertical' }}
                name="message"
                placeholder="Your Message"
                value={formData.message}
                onChange={handleChange}
                required
              />
              <button
                style={{ ...styles.submitBtn, opacity: loading ? 0.7 : 1 }}
                type="submit"
                disabled={loading}
              >
                {loading ? 'Sending...' : 'Send Message →'}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

const styles = {
  section: { background: '#fff', padding: '80px 20px' },
  container: { maxWidth: '1100px', margin: '0 auto', textAlign: 'center' },
  tag: { color: '#c41e3a', fontSize: '12px', fontWeight: 'bold', letterSpacing: '3px', marginBottom: '12px' },
  title: { color: '#1a3a5c', fontSize: '36px', fontWeight: 'bold', marginBottom: '12px' },
  subtitle: { color: '#666', fontSize: '16px', marginBottom: '48px' },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
    gap: '40px',
    textAlign: 'left'
  },
  info: { display: 'flex', flexDirection: 'column', gap: '24px' },
  infoItem: { display: 'flex', gap: '16px', alignItems: 'flex-start' },
  infoIconBox: { width: '44px', height: '44px', background: '#fff5f5', borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 },
  infoIcon: { fontSize: '20px' },
  infoTitle: { color: '#1a1a2e', fontSize: '15px', fontWeight: '600', marginBottom: '4px' },
  infoText: { color: '#666', fontSize: '14px', margin: 0 },
  socialRow: { display: 'flex', gap: '12px', flexWrap: 'wrap' },
  socialBtn: { padding: '10px 18px', background: '#f0f2f5', color: '#444', border: '1px solid #e8eaf0', borderRadius: '8px', cursor: 'pointer', fontSize: '13px', fontWeight: '600' },
  formBox: { background: '#f8f9fa', padding: '36px', borderRadius: '20px', border: '1px solid #e8eaf0' },
  formTitle: { color: '#1a1a2e', fontSize: '20px', fontWeight: 'bold', marginBottom: '24px' },
  success: { background: '#f0fff4', color: '#22c55e', padding: '12px 16px', borderRadius: '8px', marginBottom: '16px', fontSize: '14px', border: '1px solid #bbf7d0' },
  errorBox: { background: '#fff5f5', color: '#e63946', padding: '12px 16px', borderRadius: '8px', marginBottom: '16px', fontSize: '14px', border: '1px solid #ffd0d3' },
  row: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))',
    gap: '12px',
    marginBottom: '0'
  },
  input: { padding: '12px 16px', marginBottom: '14px', borderRadius: '10px', border: '1px solid #e8eaf0', background: '#fff', color: '#333', fontSize: '14px', boxSizing: 'border-box', outline: 'none', width: '100%' },
  submitBtn: { width: '100%', padding: '14px', background: '#c41e3a', color: '#fff', border: 'none', borderRadius: '10px', fontSize: '15px', cursor: 'pointer', fontWeight: 'bold' }
};

export default Contact;